import type { FC } from 'react';
import { useTheme } from '@mui/material';

interface DoughnutSkeletonProps {
  radius: number;
  circumference: number;
}

const DoughnutSkeleton: FC<DoughnutSkeletonProps> = ({
  radius,
  circumference,
}) => {
  const {
    colors: { neutral },
  } = useTheme();
  return (
    <svg
      viewBox="0 0 100 100"
      width="100%"
      height="100%"
      fill="none"
      style={{
        transform: `rotate(0deg)`,
        position: 'absolute',
        transition: 'transform 0.5s ease-out',
      }}
    >
      {/* Circle segment */}
      <circle
        cx="50"
        cy="50"
        r={radius}
        stroke={neutral[100]}
        strokeWidth={15}
        strokeDasharray={`${circumference} ${circumference}`}
      />
    </svg>
  );
};

export default DoughnutSkeleton;
